// extracted by mini-css-extract-plugin
export default {"list":"QRl2b","item":"zY2fG","active":"wTkyl","icon":"VRAKX","unactive":"_FjP1","itemButton":"AIg5W","itemLabel":"FMhug"};